import { connect } from 'react-redux';
import * as routes from 'app/routes';

import ConfirmInsurance from 'insurance/ConfirmInsurance/quick';
import InsuranceConfirm from './InsuranceConfirm';

const mapStateToProps = (state) => ({
  ConfirmInsurance,
  insurancePlanRoute: routes.quickInsurancePlan
});

export default connect(
  mapStateToProps,
  null
)(InsuranceConfirm);
